module.exports = __webpack_public_path__ + "static/media/pp-bg7.042741f5.png";